"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformUrl = exports.isValidURL = exports.isNotAllowedUrl = exports.defaultMediaProps = exports.RECOMMENDED_SIZE = exports.RECOMMENDED_MOBILE_SIZE = exports.MOBILE_TEXT_LENGTH = exports.MEDIA_COMPONENTS = exports.MAX_TEXT_LENGTH = void 0;
var _config = require("@trs/config");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultMediaProps = exports.defaultMediaProps = {
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: ''
};
var isNotAllowedUrl = exports.isNotAllowedUrl = function isNotAllowedUrl(string) {
  var unsafeLinksList = /<iframe.*|<script.*|<html.*/;
  return unsafeLinksList.test(string);
};
var isValidURL = exports.isValidURL = function isValidURL(string) {
  var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
  return res !== null;
};
var MEDIA_COMPONENTS = exports.MEDIA_COMPONENTS = {
  BANNER: 'Banner',
  MEDIA: 'Media'
};
var RECOMMENDED_SIZE = exports.RECOMMENDED_SIZE = _defineProperty(_defineProperty({}, MEDIA_COMPONENTS.BANNER, {
  width: 930,
  height: 300
}), MEDIA_COMPONENTS.MEDIA, {
  width: 400,
  height: 270
});
var RECOMMENDED_MOBILE_SIZE = exports.RECOMMENDED_MOBILE_SIZE = _defineProperty({}, MEDIA_COMPONENTS.BANNER, {
  width: '100%',
  height: '100%'
});
var MAX_TEXT_LENGTH = exports.MAX_TEXT_LENGTH = {
  URL: 500,
  ALT: 80,
  TEXT: 2500
};
var youTubeGetID = function youTubeGetID(url) {
  var id = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return id[2] !== undefined ? id[2].split(/[^0-9a-z_-]/i)[0] : id[0];
};
var transformUrl = exports.transformUrl = function transformUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (url.includes('youtube')) {
    var id = youTubeGetID(url);
    return "https://www.youtube.com/embed/".concat(id);
  }
  if (url.includes('vimeo')) {
    return url.replace('vimeo.com/', 'player.vimeo.com/video/');
  }
  return url;
};
var MOBILE_TEXT_LENGTH = exports.MOBILE_TEXT_LENGTH = 300;